import React from 'react'
import PropTypes from 'prop-types'
import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

const LakeDescription = ({ maxDepth, area, elevation, lang }) => (
  <>
    {area && (
      <ResourceDetailsBlock>
        <div className="label">
          {lang === 'en' ? `Area (km²)` : `المساحة (كم٢)`}
        </div>
        <div className="value">
          <span>{area}</span>
        </div>
      </ResourceDetailsBlock>
    )}
    {elevation && (
      <ResourceDetailsBlock>
        <div className="label">
          {lang === 'en' ? `Surface Elevation (m)` : `ارتفاع السطح (م)`}
        </div>
        <div className="value">
          <span>{elevation}</span>
        </div>
      </ResourceDetailsBlock>
    )}
    {maxDepth && (
      <ResourceDetailsBlock>
        <div className="label">
          {lang === 'en' ? `Max Depth (m)` : `أقصى عمق (م)`}
        </div>
        <div className="value">
          <span>{maxDepth}</span>
        </div>
      </ResourceDetailsBlock>
    )}
  </>
)

LakeDescription.propTypes = {
  maxDepth: PropTypes.string,
  area: PropTypes.string,
  elevation: PropTypes.string,
  lang: PropTypes.string
}

const RiverDesciription = ({ length, source, mouth, flow, lang }) => (
  <>
    {source && (
      <ResourceDetailsBlock>
        <div className="label">{lang === 'en' ? `Source` : `المصدر`}</div>
        <div className="value">{source[lang]}</div>
      </ResourceDetailsBlock>
    )}
    {mouth && (
      <ResourceDetailsBlock>
        <div className="label">{lang === 'en' ? `Mouth` : `المصب`}</div>
        <div className="value">{mouth[lang]}</div>
      </ResourceDetailsBlock>
    )}
    {length && (
      <ResourceDetailsBlock>
        <div className="label">
          {lang === 'en' ? `Length (km)` : `الطول (كم)`}
        </div>
        <div className="value">
          <span>{length}</span>
        </div>
      </ResourceDetailsBlock>
    )}
    {flow && (
      <ResourceDetailsBlock>
        <div className="label">
          {lang === 'en' ? `Flow (m³/second)` : `التدفق (م3 لكل ثانية)`}
        </div>
        <div className="value">
          <span>{flow}</span>
        </div>
      </ResourceDetailsBlock>
    )}
  </>
)

RiverDesciription.propTypes = {
  lang: PropTypes.string,
  length: PropTypes.string,
  source: PropTypes.object,
  mouth: PropTypes.object,
  flow: PropTypes.string
}

const Description = ({ lang, type, ...props }) => {
  return type === 'river' ? (
    <RiverDesciription
      lang={lang}
      length={props.length}
      source={props.source}
      mouth={props.mouth}
      flow={props.flow}
    />
  ) : (
    <LakeDescription
      lang={lang}
      maxDepth={props.maxDepth}
      area={props.area}
      elevation={props.elevation}
    />
  )
}

Description.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  lang: PropTypes.string,
  length: PropTypes.string,
  source: PropTypes.object,
  mouth: PropTypes.object,
  flow: PropTypes.string,
  maxDepth: PropTypes.string,
  area: PropTypes.string,
  elevation: PropTypes.string
}

export default Description
